<template>
	<div class="winning-list">
		<div class="flex__around__center list-header">
			<span class="fs_32 c_ff">
				共&nbsp;
				<span class="fs_50">{{count}}</span>&nbsp;位用户中奖
			</span>
		</div>

		<div class="list-content">
			<div class="flex item" v-for="(item,index) in list" :key="index">
                <img :src="item.headimgurl">
                <div class="flex column ml_20">
                    <span class="c_1a">{{item.nickname}}</span>
                    <span class="fs_24 c_4d">中奖时间：{{item.create_time}}</span>
                    <span class="fs_28 c_FF9347">{{item.title}}</span>
                </div>
            </div>
		    <jc-list :url="'Turntable/getActivityOrder'" :loads="loads" @load="getList"></jc-list>
		</div>
	</div>
</template>
<script>
export default {
    name:'WinningList',
    data(){
        return{
            count: 0,
            loads:{
                activity_id: 1,
                page:1
            },
            list:[]
        }
    },
	mounted() {
        this.loads.activity_id=this.$route.query.id;
    },
	methods: {
		getList(data) {
			this.list = data;
        },
    }
};
</script>
<style scoped>
.c_FF9347{
    color: #FF9347;
}
.winning-list {
	position: fixed;
	top: 0;
	bottom: 0;
	width: 100%;
	background:linear-gradient(159deg,rgba(254,176,56,1) 0%,rgba(255,100,71,1) 100%);
}
.list-header {
	height: 120px;
}
.index__tab {
	height: 60px;
	color: #fff;
}
.tab-item--active {
	font-weight: bold;
	border-bottom: 6px solid #fff;
}
.list-content {
	position: fixed;
	top: 120px;
	bottom: 30px;
	left: 30px;
	width: 690px;
	padding: 0 25px;
	background: #fff;
	border-radius: 10px;
}
.item {
	padding: 25px 0;
	border-bottom: 1px solid #e6e6e6;
}
.item image {
	width: 80px;
	height: 80px;
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/turntable/WinningList.vue